import { useTranslation } from '@repo/i18n'
import { Field, FieldLabel } from '#components/field'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue
} from '#components/select'

export function TwoFactorDevicePicker(props: {
	devices: { deviceId: string; name: string | null }[]
	value: string
	onChange: (deviceId: string) => void
}) {
	const { t } = useTranslation()

	return (
		<Field>
			<FieldLabel htmlFor='two-factor-totp-device'>
				{t('shared:two_factor_device_picker.device_label')}
			</FieldLabel>
			<Select
				onValueChange={(value) => props.onChange(value ?? '')}
				value={props.value}
			>
				<SelectTrigger id='two-factor-totp-device'>
					<SelectValue>
						{(value) =>
							props.devices.find(
								(device) => device.deviceId === value
							)?.name ??
							t('shared:two_factor_device_picker.device_unnamed')
						}
					</SelectValue>
				</SelectTrigger>
				<SelectContent>
					{props.devices.map((device) => (
						<SelectItem
							key={device.deviceId}
							value={device.deviceId}
						>
							{device.name ??
								t(
									'shared:two_factor_device_picker.device_unnamed'
								)}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		</Field>
	)
}
